import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ObjectManagerComponentBase } from '../../../core/component/object-manager/object-manager.base';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { PrintOrder } from '../../model/print-order';
import { PrintOrderService } from '../../service/data/print-order.service';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { standardCommand, CommandBase, Command, DeleteCommand } from '../../../core/model/command';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { UserAccountService } from '../../../common/service/user-account.service';

@Component({
    selector: 'app-print-order-manager',
    templateUrl: 'print-order-manager.component.html',
    styleUrls: ['print-order-manager.component.scss', './../../../core/component/object-manager/object-manager.template.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintOrderManagerComponent extends ObjectManagerComponentBase<PrintOrder> {
  private canManagePrintOrders = false;

  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: PrintOrderService,
    private _nativeWindow: NativeWindowService,
    accountService: UserAccountService,
    dispatcher: CommandDispatcher,
    cdf: ColumnDefinitionFactory,
    handlerResolver: StandardCommandHandlerResolver,
    private _messageService: MessageService,
    navigationService: NavigationService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    super(_dataService, _messageService, navigationService, dispatcher, handlerResolver);

    this.columnDefinition = [
      cdf.create('LEASE_AGREEMENT_DOCUMENT.CAPTION', 'caption'),
      cdf.createDateTime('COMMON.ORDERED', 'ordered'),
      cdf.createBoolean('COMMON.COMPLETED', 'isCompleted'),
    ];

    this.contextMenuDefinition = [new MenuItemDefinition('DOWNLOAD_BTN', standardCommand.download)];

    this.AddSubscription(
      accountService.current.subscribe(account => {
        this.canManagePrintOrders = account.hasAccess(ModuleNames.Invoicing, Features.ManageInvoices);
        if (this.canManagePrintOrders) {
          this.contextMenuDefinition.push(new MenuItemDefinition('DELETE_BTN', standardCommand.delete));
        }
      })
    );

    this.title = 'DASHBOARD.MENU.PRINT_ORDER';
    this.preferencesKey = 'invoice.print-orders';
  }

  canExecute(command: CommandBase): boolean {
    switch (command.id) {
      case standardCommand.delete:
        return this.canManagePrintOrders && command instanceof Command && !!command.context;

      case standardCommand.download:
        if (command instanceof Command && command.context instanceof PrintOrder) {
          if (!command.context.isCompleted) {
            this._messageService.showMessage('INVOICE.INFORMATION_TEXT.PRINT_ORDER_NOT_COMPLETED');
            return false;
          }

          return true;
        }
        return false;

      default:
        return super.canExecute(command);
    }
  }

  execute(command: CommandBase): void {
    if (command instanceof Command) {
      switch (command.id) {
        case standardCommand.download:
          this.AddSubscription(
            this._dataService.download((<Command>command).context).subscribe(res => {
              this._nativeWindow.save(res);
            })
          );
          break;

        default:
          return super.execute(command);
      }
    }
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'LEASE_AGREEMENT_DOCUMENT.CAPTION',
            'caption',
            definition.caption,
            null,
            definition.selectedFields.includes('caption')
          ),
        ];
      })
    );
  }
}
